import { NookKind } from "@nook/api-client"
import { createFileRoute } from "@tanstack/react-router"

import { parseBrowseSearch } from "@/lib/browse.js"
import { Browse } from "./index.js"

export const Route = createFileRoute("/_authed/notes")({
  validateSearch: parseBrowseSearch,
  component: () => <Browse kind={NookKind.Note} />,
})
